<template>
  <div class="main-body middleOfParent">
    <div v-if="dataReady" class="widthCenter50">
      <div style="width: 70%">
        <div>
          <div class="text-center middleOfParent mt-n12">
            <v-img
              src="../assets/auth/logo.png"
              width="300"
              height="100"
              position="center"
              alt="logo"
            ></v-img>
          </div>
          <h4 id="h4-first-col">Reset</h4>
          <h2 id="h2-first-col">Your Password?</h2>
          <div v-if="decryptResponse != 'failed'" class="sign-up-form">
            <p>
              Enter your new password and get right into your account to get
              your business back in line.
            </p>
            <p v-if="responseStatus == 'failed'" class="red--text caption">
              {{ errMessage }}
            </p>
            <v-form ref="resetPasswordForm">
              <v-text-field
                v-model="password"
                placeholder="Enter new password"
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'"
                @click:append="show2 = !show2"
                hide-details
                height="25"
                outlined
                dense
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                v-model="confirmPassword"
                placeholder="Confirm new password"
                :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show3 ? 'text' : 'password'"
                @click:append="show3 = !show3"
                hide-details
                height="25"
                outlined
                dense
                class="my-2"
                :rules="[rules.required, rules.passwordMatch]"
              ></v-text-field>
              <v-btn
                height="50"
                class="primary mr-4 white--text"
                id="btn-signup"
                :loading="loader"
                @click="resetPassword"
              >
                <h2 class="text-capitalize">Change</h2>
              </v-btn>
            </v-form>

            <v-layout class="row wrap">
              <v-flex xs12 md12 lg12>
                <p class="mt-3 ml-3">
                  Already have an account?
                  <strong>
                    <router-link to="/" class="link"> Sign In </router-link>
                  </strong>
                </p>
              </v-flex>
            </v-layout>
          </div>

          <div v-if="decryptResponse == 'failed'" class="responseReady">
            <div v-if="decryptResponse == 'failed'">
              <div>Password Reset link not valid</div>
              <div class="caption">
                Please request
                <router-link class="white--text" to="/forgot-password">
                  <b>a new password reset</b>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- VIEW END -->
    <inner-page-loader v-else class="main-view"></inner-page-loader>

    <!-- Snackbar Notification -->
    <v-snackbar
      class="snackbar"
      :color="snackBar.color"
      bottom
      right
      v-model="snackBar.active"
      :multi-line="snackBar.multiLine"
      :timeout="snackBar.timeout"
      >{{ snackBar.text }}</v-snackbar
    >
  </div>
</template>

<script>
import inner_page_loader from "@/components/innerPageLoader";
import axios from "axios";

export default {
  data() {
    return {
      token: this.$route.params.resetToken,
      show1: false,
      show2: false,
      show3: false,
      resetToken: null,
      password: "",
      confirmPassword: "",
      loader: false,
      dataReady: false,
      decryptResponse: null,
      responseReady: false,
      responseStatus: null,
      errMessage: null,
      rules: {
        required: (value) => !!value || "Required",
        password: (value) => {
          const pattern = /^(?=\S*[a-z])(?=\S*[A-Z])(?=\S*\d)(?=\S*([^\w\s]|[_]))\S{8,}$/;
          return (
            pattern.test(value) ||
            "Min. 8 characters with at least one capital letter, a number and a special character."
          );
        },
        passwordMatch: (value) =>
          value === this.password || "Password must match",
      },
      snackBar: {
        active: false,
        text: "",
        color: "",
        multiLine: "",
        timeout: null,
      },
    };
  },
  methods: {
    resetPassword() {
      if (this.$refs.resetPasswordForm.validate()) {
        this.loader = true;

        axios
          .post(
            "/api/v1/auth/password/" + this.resetToken,
            {
              password: this.password,
              confirmPassword: this.confirmPassword,
            },
            {
              headers: { Authorization: this.$store.state.token },
            }
          )
          .then(() => {
            this.responseReady = true;
            this.responseStatus = "success";
            this.loader = false;

            setTimeout(() => {
              this.$router.push("/");
            }, 1000);

            this.snackBar.active = true;
            this.snackBar.text = "Password reset successful";
            this.snackBar.color = "success";
            this.snackBar.timeout = this.$store.state.snackBarDuration;
          })
          .catch((error) => {
            this.responseReady = true;
            this.responseStatus = "failed";
            this.errMessage = error.response.data.message;
            this.loader = false;

            this.snackBar.active = true;
            this.snackBar.text =
              error.response.data.message || "Error resetting password";
            this.snackBar.color = "error";
            this.snackBar.timeout = this.$store.state.snackBarDuration;
          });
      }
    },
    decryptResetToken() {
      axios
        .get("/api/v1/auth/password/" + this.token)
        .then((response) => {
          this.resetToken = response.data.data.resetToken;

          this.dataReady = true;
        })
        .catch(() => {
          this.dataReady = true;
          this.decryptResponse = "failed";
        });
    },
  },
  watch: {
    decryptResponse(val) {
      if (val == "failed") {
        //   errorMessage =
      }
    },
  },
  created() {
    this.decryptResetToken();
  },
  components: {
    "inner-page-loader": inner_page_loader,
  },
};
</script>

<style scoped>
.main-body {
  height: 100vh;
  width: 100%;
  font-family: "Montserrat";
}

#h4-first-col {
  margin-left: 4%;
  font-style: bold;
  font-size: 26px;
  color: black;
  font-family: "Montserrat";
}

#h2-first-col {
  color: grey;
  margin-left: 4%;
  font-weight: normal;
  font-family: "Montserrat";
}

#btn-signup {
  width: 100%;
}

.link {
  color: black;
  text-decoration: none;
}

.responseReady {
  background-color: #e44a4a;
  padding: 20px;
  margin-top: 50px;
  border-radius: 5px;
  margin-left: 4%;
  color: white;
}
</style>
